import { debounce, ModalManager, fallbackCopyToClipboard } from "../utils/utils";

function followAndShareWidgetPosition() {
    const widgetDropdownElements = document.querySelectorAll('.widget.dropdown');
    
    if (widgetDropdownElements.length > 0) {
        widgetDropdownElements.forEach(function(widgetEl) {
            if (widgetEl.classList.contains("ignore-placement-fix")) {
                return;
            }
            
            const rect = widgetEl.getBoundingClientRect();
            const widgetOffsetLeft = rect.left;
            const widgetWidth = rect.width;
            const bodyWidth = document.body.clientWidth;
            const widgetOffsetRight = bodyWidth - widgetWidth - widgetOffsetLeft;
            
            const widgetMenuWidth = 300;
            const offset = 5;
            const widgetCaretPosition = widgetMenuWidth / 2 - offset;
            
            const widgetMenuEl = widgetEl.querySelector('.widget-menu');
            if (!widgetMenuEl) return;
            
            if (widgetOffsetLeft > widgetCaretPosition && widgetOffsetRight > widgetCaretPosition) {
                widgetMenuEl.classList.remove('widget-menu-left', 'widget-menu-center', 'widget-menu-right');
                widgetMenuEl.classList.add('widget-menu-center');
            }
            else if (
                widgetOffsetLeft > widgetCaretPosition &&
                widgetOffsetRight < widgetCaretPosition
            ) {
                widgetMenuEl.classList.remove('widget-menu-left', 'widget-menu-center', 'widget-menu-right');
                widgetMenuEl.classList.add('widget-menu-left');
            }
            else if (
                widgetOffsetLeft < widgetCaretPosition &&
                widgetOffsetRight > widgetCaretPosition
            ) {
                widgetMenuEl.classList.remove('widget-menu-left', 'widget-menu-center', 'widget-menu-right');
                widgetMenuEl.classList.add('widget-menu-right');
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    // Share widget toggle functionality
    document.querySelectorAll(".page-top__content .share-widget__toggle-button").forEach(button => {
        button.addEventListener('click', function() {
            const parent = this.parentElement;
            const navElement = document.querySelector(".bs4-nav.landing-page-nav");
            
            if (navElement) {
                navElement.style.zIndex = parent.classList.contains("show") ? "1" : "9999";
            }
        });
    });

    // URL copy functionality
    const copyURLButton = document.getElementById('copyURL');
    if (copyURLButton) {
        copyURLButton.addEventListener('click', function() {
            const url = window.location.href.split('#')[0];
            
            // Use modern Clipboard API with fallback
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(url)
                    .catch(() => fallbackCopyToClipboard(url));
            } else {
                fallbackCopyToClipboard(url);
            }

            closeShareWidget();
        });
    }

    // Register Hero Landing Page modal with ModalManager
    // ModalManager.register('HeroLandingPage', null, (modalElement) => {
    //     // Reset YouTube iframe source on close
    //     const iframe = modalElement.querySelector("iframe");
    //     if (iframe) {
    //         const src = iframe.getAttribute("src");
    //         iframe.setAttribute("src", src);
    //     }
    // });
    
    // // Initialize ModalManager global events
    // ModalManager.setupGlobalEvents();
});

document.addEventListener('DOMContentLoaded', () => {
    const printButtons = document.querySelectorAll('.share-widget .print');

    printButtons.forEach(button => {
        button.addEventListener('click', function() {
            closeShareWidget()
            
            window.print();
        });
    });

    document.querySelectorAll(".page-top__content .share-widget__toggle-button").forEach(button => {
        button.addEventListener('click', function() {
            const parent = this.parentElement;
            const navElement = document.querySelector(".bs4-nav.landing-page-nav");
            
            if (navElement) {
                if (parent.classList.contains("show")) {
                    navElement.style.zIndex = "1";
                } else {
                    navElement.style.zIndex = "9999";
                }
            }
        });
    });
});


const closeShareWidget = () => {
    const shareWidgets = document.querySelectorAll('.share-widget');
    const shareWidgetMenus = document.querySelectorAll('.share-widget__menu');
    
    shareWidgets.forEach(widget => widget.classList.remove('show'));
    shareWidgetMenus.forEach(menu => menu.classList.remove('show'));
}

followAndShareWidgetPosition();
window.addEventListener('resize', debounce(followAndShareWidgetPosition, 250));